/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { CREATE_COMPLIANCE_DOCS } from '../graphql';
import { VApplication } from '@/application';
import moment from 'moment-timezone';
import { UploadDocService } from '@services/uploadService';
import { toast } from 'react-hot-toast';
import { useOrgId } from '../provider';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

const uploadSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.UploadDocService') as UploadDocService;
};

export interface ICreateOrgComplianceMethods extends IPluginMethodMap {
  createOrgCompliance(args: any): Promise<any>;
}

export class CreateOrgComplianceService implements IAgentPlugin {
  readonly methods: ICreateOrgComplianceMethods;

  constructor() {
    this.methods = {
      createOrgCompliance: this.createOrgCompliance.bind(this),
    };
  }

  async createOrgCompliance(args: any) {
    let organizationId: string;
    const { orgId } = useOrgId();
    console.log(`args in service`, args);
    const storageService = StorageModule?.getInstance();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    const orgDetails = storageService?.get('myProfile', 'local')?.orgData;
    const localOrgId = orgDetails?.id;
    organizationId = orgId || localOrgId;
    let icon: string;
    if (args?.logo) {
      icon = await uploadSrv()?.uploadDoc(args?.logo?.base64);
    }
    let document: string;
    if (
      args?.document &&
      Array.isArray(args?.document) &&
      args?.document.length > 0
    ) {
      document = await uploadSrv()?.uploadDoc(args?.document[0]?.base64);
    }
    console.log(`icon :`, icon, `document`, document);
    try {
      if (client && document) {
        console.log(`icon : created`);
        const res = await client.mutate({
          mutation: CREATE_COMPLIANCE_DOCS,
          variables: {
            where: {
              id: organizationId,
            },
            update: {
              complianceDocs: [
                {
                  create: [
                    {
                      node: {
                        name: args?.name,
                        description: args?.description,
                        icon: icon?.url,
                        doc: document?.url,
                        validFrom: args?.validFrom,
                        validUntil: args?.validUntil,
                      },
                    },
                  ],
                },
              ],
            },
          },
          fetchPolicy: 'no-cache',
        });
        if (res?.data) {
          return {
            ...res?.data?.updateOrgs,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return err;
    }
  }
}
